import { render, staticRenderFns } from "./QuestionPreview.vue?vue&type=template&id=dc024ed8&"
import script from "./QuestionPreview.vue?vue&type=script&lang=ts&"
export * from "./QuestionPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports